export default __webpack_public_path__ + "static/niranjan-f97fc2a54d8b708c21f9d8a731cbcce5.png";